module.exports = __webpack_public_path__ + "static/media/04-booking-calendar.d5f7dc6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/how-courses-work/04-booking-calendar.jpg
// module id = 373
// module chunks = 0